import WhitepapersIndex from './WhitepapersIndex'

export default WhitepapersIndex
